import { Component, OnInit, Input } from '@angular/core';
import { AppBaseComponent } from '@utils';
import {
  ControlContainer,
  FormBuilder

} from '@angular/forms';
import { CityService } from '@services';

@Component({
  selector: 'app-labor-data',
  templateUrl: './labor-data.component.html',
  styleUrls: ['./labor-data.component.scss'],
})
export class LaborDataComponent extends AppBaseComponent implements OnInit {
  @Input() tramiteObject: any;
  @Input() title!: string;
  @Input() stateInput: boolean = true;

  public laborForm; //: FormGroup;
  public showForm: boolean;
  public departaments: any[] = [];
  public municipios: any[] = [];
  prueba: string;
  constructor(
    public fb: FormBuilder,
    public cityService: CityService,
    private controlContainer: ControlContainer
  ) {
    super();
  }

  ngOnInit(): void {
    this.laborForm = this.controlContainer.control;
    this.laborForm = this.laborForm.controls['laborForm'];

    this.cityService.getDepartaments().subscribe((resp) => (this.departaments = resp.data));


    if(this.laborForm.get('companyDepartmentId').value != null) {
      this.cityService.getMunByDepaId(this.laborForm.get('companyDepartmentId').value).subscribe(resp => {
        this.municipios = resp.data
      });
    }

    this.showForm = this.laborForm.get('companyWorking').value == '1';
  }

  getMunicipios(idDep: number): void {
    this.cityService
      .getMunByDepaId(idDep)
      .subscribe((resp) => (this.municipios = resp.data));
    console.log('municipio', this.municipios);
  }

  getErrorMessage(field: string): string {
    let message;
    const onlyNumbers: Array<string> = ['companyCellPhone', 'companyPhone'];
    if(this.isTouchedField(this.laborForm, field))
    {
      if(this.laborForm?.get(field).hasError('required'))
      {
        message = 'Es requerido';
      }
      else if(this.laborForm?.get(field).hasError('maxlength'))
      {
        message = `Permite hasta `+this.laborForm?.get(field).errors.maxlength.requiredLength+` caracteres`;
      }
      else if(this.laborForm?.get(field).hasError('minlength'))
      {
        message = `Permite hasta `+this.laborForm?.get(field).errors.minlength.requiredLength+` caracteres`;
      }
      else if(this.laborForm?.get(field).hasError('pattern') && onlyNumbers.includes(field))
      {
        message = `Solo se admiten numeros`;
      }
    }


    return message;
  }


}
